import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { setModal } from "../../../redux/actions/modals";
import { DROPDOWN_MODAL } from "../modals/constants";
import ChevronLeft from "../svgs/chevron-left";

interface Props {
  options: DropdownOption[];
  loading?: boolean;
  label?: string;
  className?: string;
  value: string | number | null;
  onChange(value: string | number | null): void;
  empty?: string;
  labelPrefix?: string;
}
export type DropdownOption = {
  key?: number | string;
  label: string | number;
  value: number | string | null;
};

const DropDown: React.FC<Props> = (props) => {
  const { options, label, value, className, onChange, loading, empty, labelPrefix } = props;
  const selectedItem = options?.find((i) => i.value === value);
  const menu = useRef<HTMLUListElement>(null);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();

  const handleSelection = (option: DropdownOption) => {
    menu.current?.blur();
    onChange(option.value);
  };
  const openDropdown = () => {
    dispatch(
      setModal({
        modal: DROPDOWN_MODAL,
        visible: true,
        data: { title: label, options, value, onChange: handleSelection },
      })
    );
  };

  const isEmpty = options.length === 0;

  return (
    <div
      onClick={openDropdown}
      tabIndex={0}
      ref={dropdownRef}
      className={`flex  dropdown dropdown-right items-center justify-between ${className}`}
    >
      <div className={`flex flex-col justify-center p-1`}>
        <div>
          {labelPrefix && `${labelPrefix}: `}
          {loading ? (
            <i className="fas fa-spinner animate-spin" />
          ) : isEmpty ? (
            empty
          ) : selectedItem ? (
            selectedItem.label
          ) : (
            label
          )}
        </div>
      </div>
      <div className="ml-1 transform -rotate-90">
        <ChevronLeft />
      </div>
    </div>
  );
};

export default DropDown;
